import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';

export interface IImportModalState {
  isDownloading: boolean;
  isCheckDifferenceRunning: boolean;
  isUploading: boolean;
}
@Module({ dynamic: true, store, name: 'importModalModule', namespaced: true })
class ImportModalModule extends VuexModule implements IImportModalState {
  isDownloading: boolean = false;
  isCheckDifferenceRunning: boolean = false;
  isUploading: boolean = false;

  @Mutation
  setIsDownloading(value: boolean) {
    this.isDownloading = value;
  }

  @Mutation
  setIsCheckDifferenceRunning(value: boolean) {
    this.isCheckDifferenceRunning = value;
  }

  @Mutation
  setIsUploading(value: boolean) {
    this.isUploading = value;
  }
}

export const importModalModule = getModule(ImportModalModule);
